import { Typography, Box } from '@mui/material';
import Stack from '@mui/material/Stack';
import { StyleConstants, Styles } from '../Styles';
import '../App.css';
import BrownLightIcon from './BrownLightIcon';
import RedLightIcon from './RedLightIcon';

const FaultLightStatusStack = () => {
    return (
        <Stack direction="row" sx={{ color: StyleConstants.fontColor, gap: 3 }}>
            <Typography sx={{ ...Styles.contentFont2, alignContent: 'center', alignItems: 'center' }}>
                Fault Level:
            </Typography>

            <Stack direction="row" sx={{ ...Styles.contentFont2, alignContent: 'center', alignItems: 'center', gap: 1 }}>
                <RedLightIcon />
                <Box>
                    Level I
                </Box>
            </Stack>

            <Stack direction="row" sx={{ ...Styles.contentFont2, alignContent: 'center', alignItems: 'center', gap: 1 }}>
                <BrownLightIcon />
                <Box>
                    Level II
                </Box>
            </Stack>
        </Stack>
    );
};

export default FaultLightStatusStack;